// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { Download } from "lucide-react";
// import { useDispatch, useSelector } from "react-redux";

// import "./CdsReport.css";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
// import { toast } from "react-toastify";

// const CdsReport = () => {
//   const dispatch = useDispatch();
//   const { profile } = useSelector((state) => state.userProfile);

//   /* ---------------- STATES ---------------- */
//   const [centers, setCenters] = useState([]);
//   const [groups, setGroups] = useState([]);
//   const [selectedCenter, setSelectedCenter] = useState("");
//   const [selectedGroup, setSelectedGroup] = useState("");
//   const [dayFilter, setDayFilter] = useState("");
//   const [loanTypeFilter, setLoanTypeFilter] = useState("");
//   const [fromDate,setFromDate]=useState("");
//   const [toDate,setToDate]=useState("");

//   const [emiData, setEmiData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [hasSearched, setHasSearched] = useState(false);

//   const [searchQuery, setSearchQuery] = useState("");
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [company, setCompany] = useState("");

//   const ITEMS_PER_PAGE_OPTIONS = [10, 20, 50, 100, "All"];

//   const companyName = company?.name || profile?.branchName || "Company";

//   const selectedCenterName =
//     centers.find((c) => c.id == selectedCenter)?.CenterName || "All";

//   const selectedCenterAddress =centers.find((c) => c.id == selectedCenter)?.city || "All";

//   const selectedGroupName =
//     groups.find((g) => g.id == selectedGroup)?.groupname || "All";

//   /* ---------------- PROFILE ---------------- */
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   /* ---------------- FETCH CENTERS ---------------- */
//   useEffect(() => {
//     if (!profile?.id) return;

//     const fetchCenters = async () => {
//       try {
//         const res = await axios.get(
//           `https://payyug.in/api/group/centre?LoanofficerId=${profile.id}&limit=10000`,
//         );
//         setCenters(res.data?.data || []);
//       } catch (error) {
//         console.error("Center fetch error:", error);
//       }
//     };

//     fetchCenters();
//   }, [profile?.id]);

//   /* ---------------- FETCH GROUPS ---------------- */
//   useEffect(() => {
//     if (!selectedCenter) {
//       setGroups([]);
//       setSelectedGroup("");
//       return;
//     }

//     const fetchGroups = async () => {
//       try {
//         const res = await axios.get(
//           `https://payyug.in/api/groupupdate/getall?LoanofficerId=${profile?.id}&CenterId=${selectedCenter}&limit=10000`,
//         );
//         setGroups(res.data?.data || []);
//       } catch (error) {
//         console.error("Group fetch error:", error);
//       }
//     };

//     fetchGroups();
//   }, [selectedCenter, profile?.id]);

//   /* ---------------- FETCH EMI ---------------- */
//   const fetchEmis = async (page = 1) => {
//     if (!profile?.superAdminId) return;

//     try {
//       setLoading(true);
//       setHasSearched(true);

//       const res = await axios.get(
//         "https://payyug.in/api/group-loan/emi/list-filter",
//         {
//           params: {
//             superAdminId: profile.superAdminId,
//             centerId: selectedCenter || undefined,
//             groupId: selectedGroup || undefined,
//             page,
//             filterType: dayFilter || undefined,
//             loanType: loanTypeFilter || undefined,
//             fromDate,
//             toDate,
//             search: searchQuery || undefined,
//             limit: itemsPerPage === "All" ? 100000 : itemsPerPage,
//           },
//         },
//       );

//       if (res.data?.success) {
//         setEmiData(res.data.data || []);
//         setCurrentPage(res.data.currentPage || page);
//         setTotalPages(res.data.totalPages || 1);
//         setTotalRecords(res.data.totalRecords || 0);
//       } else {
//         setEmiData([]);
//         setTotalPages(1);
//         setTotalRecords(0);
//         toast.error(res.data.message || "No data found");
//       }
//     } catch (error) {
//       console.error("EMI fetch error:", error);
//       toast.error("Failed to fetch data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!hasSearched) return;
//     fetchEmis(currentPage);
//   }, [currentPage, itemsPerPage]);

//   useEffect(() => {
//     if (hasSearched) {
//       const delayDebounceFn = setTimeout(() => {
//         setCurrentPage(1);
//         fetchEmis(1);
//       }, 400);
//       return () => clearTimeout(delayDebounceFn);
//     }
//   }, [searchQuery]);

//   /* ---------------- FILTER SUBMIT ---------------- */
//   const handleFilter = () => {
//     if (!selectedCenter && !selectedGroup && !loanTypeFilter && !dayFilter) {
//       toast.warn(
//         "Please select at least one filter parameter (e.g. Center) to search.",
//       );
//       return;
//     }
//     setCurrentPage(1);
//     fetchEmis(1);
//     setEmiData([]);
//   };

//   useEffect(() => {
//     const fetchCompany = async () => {
//       try {
//         const res = await axios.get(
//           `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`,
//         );
//         const data = res?.data;
//         if (res.status === 200 && data) {
//           if (data.logo) {
//             data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
//           }
//           setCompany(data);
//         }
//       } catch (err) {
//         console.error("Failed to fetch company details", err);
//       }
//     };

//     if (profile?.superAdminId) fetchCompany();
//   }, [profile?.superAdminId]);

//   const toDataURL = (url) =>
//     fetch(url)
//       .then((response) => response.blob())
//       .then(
//         (blob) =>
//           new Promise((resolve, reject) => {
//             const reader = new FileReader();
//             reader.onloadend = () => resolve(reader.result);
//             reader.onerror = reject;
//             reader.readAsDataURL(blob);
//           }),
//       );

// const handleCdsDownload = async () => {
//     const doc = new jsPDF("l", "pt", "a4");
//     const pageWidth = doc.internal.pageSize.getWidth();
//     const pageHeight = doc.internal.pageSize.getHeight();

//     let logoBase64 = null;
//     if (company?.logoUrl) {
//       try {
//         logoBase64 = await toDataURL(company.logoUrl);
//       } catch (e) {
//         console.error("Logo conversion error: ", e);
//       }
//     }

//     const totalDueSum = emiData.reduce(
//       (acc, r) => acc + Number(String(r.emiAmount || 0).replace(/,/g, "")),
//       0,
//     );

//     const renderCdsHeader = (pdfDoc) => {
//       // Title
//       pdfDoc.setFont("helvetica", "bold");
//       pdfDoc.setFontSize(14);
//       pdfDoc.setTextColor(0, 0, 0);
//       pdfDoc.text("CENTER DEMAND SHEET", pageWidth / 2, 35, {
//         align: "center",
//       });

//       // Logo (50x50)
//       if (logoBase64) {
//         pdfDoc.addImage(logoBase64, "PNG", 40, 15, 50, 50);
//       }

//       // Company Name Wrap
//       pdfDoc.setFontSize(14);
//       pdfDoc.setTextColor(40, 40, 40);

//       const splitCompanyName = pdfDoc.splitTextToSize(companyName.toUpperCase(), 250);
//       pdfDoc.text(splitCompanyName, pageWidth - 40, 35, {
//         align: "right",
//       });

//       const companyLinesCount = Array.isArray(splitCompanyName) ? splitCompanyName.length : 1;
//       let detailsY = 35 + (companyLinesCount * 15);

//       pdfDoc.setFont("helvetica", "normal");
//       pdfDoc.setFontSize(8.5);
//       pdfDoc.setTextColor(80, 80, 80);

//       const lines = [
//         `CIN: ${company?.cin || "-"}`,
//         `Regd. Office: ${profile?.branchName||company?.address || "-"}`,
//         `Contact: ${company?.contact || "-"}`,
//         `Email: ${company?.email || "-"}`
//       ];

//       lines.forEach((line) => {
//         const splitText = pdfDoc.splitTextToSize(line, 250);
//         pdfDoc.text(splitText, pageWidth - 40, detailsY, { align: "right" });
//         detailsY += (splitText.length * 11);
//       });

//       let currentY = detailsY + 20;

//       pdfDoc.setFontSize(10);
//       pdfDoc.setTextColor(0, 0, 0);

//       const branchLabel = "Branch";
//       const branchValue = `:  ${profile?.branchName || "N/A"}`;
//       const villageLabel = "Village";
//       const villageValue = `:  ${selectedCenterAddress}`;

//       const splitBranchVal = pdfDoc.splitTextToSize(branchValue, 280);
//       const splitVillageVal = pdfDoc.splitTextToSize(villageValue, 250);

//       pdfDoc.setFont("helvetica", "bold");
//       pdfDoc.text(branchLabel, 40, currentY);
//       pdfDoc.setFont("helvetica", "normal");
//       pdfDoc.text(splitBranchVal, 120, currentY);

//       pdfDoc.setFont("helvetica", "bold");
//       pdfDoc.text(villageLabel, 450, currentY);
//       pdfDoc.setFont("helvetica", "normal");
//       pdfDoc.text(splitVillageVal, 530, currentY);

//       const maxRow1Lines = Math.max(splitBranchVal.length, splitVillageVal.length);
//       currentY += (maxRow1Lines * 14) + 8;

//       const centerLabel = "Center Name";
//       const centerValue = `:  ${selectedCenterName}`;
//       const officerLabel = "Loan Officer";
//       const officerValue = `:  `;

//       const splitCenterVal = pdfDoc.splitTextToSize(centerValue, 280);
//       const splitOfficerVal = pdfDoc.splitTextToSize(officerValue, 250);

//       pdfDoc.setFont("helvetica", "bold");
//       pdfDoc.text(centerLabel, 40, currentY);
//       pdfDoc.setFont("helvetica", "normal");
//       pdfDoc.text(splitCenterVal, 120, currentY);

//       pdfDoc.setFont("helvetica", "bold");
//       pdfDoc.text(officerLabel, 450, currentY);
//       pdfDoc.setFont("helvetica", "normal");
//       pdfDoc.text(splitOfficerVal, 530, currentY);

//       const maxRow2Lines = Math.max(splitCenterVal.length, splitOfficerVal.length);
//       const finalHeaderBottomY = currentY + (maxRow2Lines * 14) + 15;

//       return finalHeaderBottomY;
//     };

//     const firstPageTableStartY = renderCdsHeader(doc);

//     const tableBody = emiData.map((r, i) => {
//       const today = new Date();
//       today.setHours(0, 0, 0, 0);

//       const dueDate = r.dueDate ? new Date(r.dueDate) : null;
//       if (dueDate) {
//         dueDate.setHours(0, 0, 0, 0);
//       }

//       const isPastDue = dueDate && today > dueDate;
//       const isUnpaid = r.status.toLowerCase() !== "paid" && r.status.toLowerCase() !== "success";

//       let overdueAmount = 0;
//       if (isPastDue && isUnpaid) {
//         overdueAmount += Number(r.emiAmount || 0);
//       }

//       return [
//         i + 1,
//         r.loanAccount?.groupName || "N/A",
//         r.dueDate ? new Date(r.dueDate).toLocaleDateString("en-GB") : "N/A",
//         r.loanAccount?.memberName || "N/A",
//         r?.member?.fatherName || r?.member?.guardianName || r?.member?.husbandName || "N/A",
//         r.loanAccount?.loanAccountNumber || "N/A",
//         r.installmentNo || "N/A",
//         r.outstanding ? `${r.outstanding}` : "0",
//         r.emiAmount ? `${r.emiAmount}` : "0",
//         `${overdueAmount}`,
//         "",
//         "",
//         "",
//       ];
//     });

//     const totalOverdueSum = emiData.reduce((acc, r) => {
//       const today = new Date();
//       today.setHours(0, 0, 0, 0);
//       const dueDate = r.dueDate ? new Date(r.dueDate) : null;
//       if (dueDate) dueDate.setHours(0, 0, 0, 0);

//       const isPastDue = dueDate && today > dueDate;
//       const isUnpaid = r.status.toLowerCase() !== "paid" && r.status.toLowerCase() !== "success";

//       return acc + (isPastDue && isUnpaid ? Number(r.emiAmount || 0) : 0);
//     }, 0);

//     const totalsRow = [
//       {
//         content: "Center Totals:",
//         colSpan: 8,
//         styles: { halign: "right", fontStyle: "bold" },
//       },
//       { content: `${totalDueSum.toFixed(2)}`, styles: { fontStyle: "bold" } },
//       { content: `${totalOverdueSum.toFixed(2)}`, styles: { fontStyle: "bold" } },
//       { content: "", colSpan: 2 },
//     ];
//     tableBody.push(totalsRow);

//     autoTable(doc, {
//       startY: firstPageTableStartY,
//       head: [
//         [
//           "Sl.No",
//           "Group Name",
//           "Due Date",
//           "Client Name",
//           "Relationship Name",
//           "Account No.",
//           "Inst. No.",
//           "O/S",
//           "EMI",
//           "OverDue Amount",
//           "Adv Amount",
//           "Total Collection",
//           "Client Sign",
//         ],
//       ],
//       body: tableBody,
//       theme: "grid",
//       styles: {
//         fontSize: 9,
//         cellPadding: 5,
//         halign: "center",
//         valign: "middle",
//         textColor: 0,
//       },
//       headStyles: {
//         fillColor: [255, 255, 255],
//         textColor: 0,
//         fontStyle: "bold",
//         lineWidth: 0.5,
//         lineColor: 150,
//       },
//       columnStyles: {
//         1: { halign: "left" },
//         3: { halign: "left" },
//       },
//       margin: { top: 35, bottom: 45 },
//       pageBreak: "auto",
//     });

//     /* ================= SUMMARY SHEET ================= */
//     doc.addPage([841.89, 595.28], "landscape");

//     const summaryPageContentStartY = renderCdsHeader(doc);
//     let startY = summaryPageContentStartY + 10;

//     // Left Side Info Boxes
//     doc.rect(40, startY, 400, 60);
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(9);
//     doc.text("CM Conduct Date: ________________", 48, startY + 20);
//     doc.text("CM Start Time: _________", 200, startY + 20);
//     doc.text("CM End Time: _________", 320, startY + 20);
//     doc.text("Total Members in center: _________", 48, startY + 45);
//     doc.text("Members Present: _________", 240, startY + 45);

//     doc.rect(40, startY + 70, 400, 40);
//     doc.text(`LO Name & Emp Id : ${profile?.name || "N/A"}`, 48, startY + 85);
//     doc.text(
//       "Remark if any : ____________________________________________________",
//       48,
//       startY + 100,
//     );

//     doc.rect(40, startY + 120, 400, 70);
//     doc.text(
//       "Visitor's Name & Emp Id : _____________________  Department: ___________",
//       48,
//       startY + 135,
//     );
//     doc.text(
//       "Remark if any : ____________________________________________________",
//       48,
//       startY + 155,
//     );
//     doc.text("Signature : _______________________", 48, startY + 180);

//     // Right side Matrix Denomination Table
//     autoTable(doc, {
//       startY: startY,
//       margin: { left: 470 },
//       tableWidth: 330,
//       head: [["Denomination", "Amount"]],
//       body: [
//         ["2000 X", ""],
//         ["500 X", ""],
//         ["200 X", ""],
//         ["100 X", ""],
//         ["50 X", ""],
//         ["20 X", ""],
//         ["10 X", ""],
//         ["5 X", ""],
//         ["Coins", "(If any)"],
//         ["Total", "Rupees:"],
//       ],
//       theme: "grid",
//       styles: { fontSize: 8, cellPadding: 4, halign: "center" },
//       headStyles: {
//         fillColor: [245, 245, 245],
//         textColor: 0,
//         fontStyle: "bold",
//       },
//       columnStyles: { 0: { halign: "right", fontStyle: "bold", width: 150 } },
//     });

//     let footerY = startY + 230;
//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(9);
//     doc.text("Center Leader Declaration:", 40, footerY);
//     doc.setFont("helvetica", "normal");
//     doc.text(
//       "I hereby confirm that the recorded information related to our loan repayment and saving is true and we have handed over the required amount to loan officer.",
//       165,
//       footerY,
//       { maxWidth: 630 },
//     );

//     doc.setFont("helvetica", "bold");
//     doc.text(
//       "Signature of Center Leader : _____________________",
//       40,
//       footerY + 45,
//     );
//     doc.text(
//       "Signature of Loan Officer : _____________________",
//       480,
//       footerY + 45,
//     );

//     doc.setFontSize(8);
//     doc.setFont("helvetica", "normal");
//     doc.text(
//       "Disclaimer: - In case of Branch deposit by Member/Center Leader the responsibility of depositing the collection safely at branch lies solely with concerned member/Center leader.\nThey must ensure that the CDS copy received has Branch Stamp on it after they deposit the collection in Branch.",
//       40,
//       footerY + 80,
//       { maxWidth: 760 },
//     );

//     doc.setFont("helvetica", "italic");
//     doc.text(
//       "Please keep this copy as a proof of your repayment towards loan & savings",
//       40,
//       footerY + 130,
//     );

//     const totalPagesCount = doc.internal.getNumberOfPages();
//     for (let i = 1; i <= totalPagesCount; i++) {
//       doc.setPage(i);
//       doc.setFont("helvetica", "normal");
//       doc.setFontSize(9);
//       doc.setTextColor(50);
//       doc.text(
//         `Page ${i} of ${totalPagesCount}`,
//         pageWidth / 2,
//         pageHeight - 15,
//         {
//           align: "center",
//         },
//       );
//     }

//     doc.save(`CDS_Report_${selectedCenterName}.pdf`);
// };

//   return (
//     <div className="gledr-container">
//       <h1 className="gledr-heading">
//         <i className="bi bi-file-earmark-text"></i> Center Demand
//         sheet
//       </h1>

//       {/* FILTER PANEL */}
//       <div className="gledr-filterBox">
//         <div className="gledr-filter-title">Filter By</div>

//         <div className="gledr-filter-wrapper">
//           <div className="gledr-filter-item">
//             <div className="gledr-filter">
//               <label>Loan Type</label>
//               <select
//                 value={loanTypeFilter}
//                 onChange={(e) => setLoanTypeFilter(e.target.value)}
//               >
//                 <option value="">All Types</option>
//                 <option value="FIXED">Fixed Loan</option>
//                 <option value="INDIVIDUAL">Individual Loan</option>
//               </select>
//             </div>

//             <div className="gledr-filter">
//               <label>Select Center</label>
//               <select
//                 value={selectedCenter}
//                 onChange={(e) => setSelectedCenter(e.target.value)}
//               >
//                 <option value="">Select Center</option>
//                 {centers.map((c) => (
//                   <option key={c.id} value={c.id}>
//                     {c.CenterName}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="gledr-filter">
//               <label>Select Group</label>
//               <select
//                 value={selectedGroup}
//                 onChange={(e) => setSelectedGroup(e.target.value)}
//                 disabled={!selectedCenter}
//               >
//                 <option value="">All Groups</option>
//                 {groups.map((g) => (
//                   <option key={g.id} value={g.id}>
//                     {g.groupname}, {g.groupcode}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="gledr-filter">
//               <label>Select Filter</label>
//               <select
//                 value={dayFilter}
//                 onChange={(e) => setDayFilter(e.target.value)}
//               >
//                 <option value="">All</option>
//                 <option value="today">Today</option>
//                 <option value="tomorrow">Tomorrow</option>
//                 <option value="pending">Pending</option>
//                 <option value="overdue">Overdue</option>
//               </select>
//             </div>

//             <div className="gledr-filter">
//               <label>From Date</label>
//               <input
//               type="date"
//                 value={fromDate}
//                 onChange={(e) => setFromDate(e.target.value)}
//               />
//             </div>
//             <div className="gledr-filter">
//               <label>To Date</label>
//               <input
//               type="date"
//                 value={toDate}
//                 onChange={(e) => setToDate(e.target.value)}
//               />
//             </div>
//           </div>

//           <div className="gledr-filter-submit-btn">
//             <button className="submit-btn" onClick={handleFilter}>
//               submit
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* SINGLE CDS DOWNLOAD BUTTON */}
//       {hasSearched && emiData.length > 0 && (
//         <div
//           className="gledr-pdf-download-btns"
//           style={{
//             display: "flex",
//             justifyContent: "flex-end",
//             marginBottom: "15px",
//           }}
//         >
//           <button
//             onClick={handleCdsDownload}
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: "8px",
//               backgroundColor: "#22c55e",
//               color: "#ffffff",
//               padding: "10px 20px",
//               fontSize: "14px",
//               fontWeight: "600",
//               borderRadius: "6px",
//               border: "none",
//               cursor: "pointer",
//               boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//               transition: "background-color 0.2s ease",
//             }}
//             onMouseEnter={(e) =>
//               (e.currentTarget.style.backgroundColor = "#16a34a")
//             }
//             onMouseLeave={(e) =>
//               (e.currentTarget.style.backgroundColor = "#22c55e")
//             }
//           >
//             <Download size={16} /> CDS Download
//           </button>
//         </div>
//       )}

//       {/* SEARCH + PER PAGE */}
//       {hasSearched && emiData.length > 0 && (
//         <div className="gledr-report-filter">
//           <input
//             placeholder="Search..."
//             value={searchQuery}
//             onChange={(e) => {
//               setSearchQuery(e.target.value);
//             }}
//           />

//           <div className="gledr-report-filter-inputs">
//             <label>Show </label>
//             <select
//               value={itemsPerPage}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 setItemsPerPage(value === "All" ? "All" : Number(value));
//                 setCurrentPage(1);
//               }}
//             >
//               {ITEMS_PER_PAGE_OPTIONS.map((n) => (
//                 <option key={n} value={n}>
//                   {n}
//                 </option>
//               ))}
//             </select>
//             <span> entries</span>
//           </div>
//         </div>
//       )}

//       {/* DATA TABLE */}
//       <div className="gledr-report-table-container">
//         <table className="gledr-report-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Group Name</th>
//               <th>Due Date</th>
//               <th>Client Name</th>
//               <th>Relationship Name</th>
//               <th>Mobile No</th>
//               <th>Account No.</th>
//               <th>Installment No.</th>
//               <th>Outstanding</th>
//               <th>EMI Amount</th>
//               <th>OverDue Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             {loading ? (
//               <tr>
//                 <td colSpan="9" align="center">
//                   Loading...
//                 </td>
//               </tr>
//             ) : !hasSearched ? (
//               <tr>
//                 <td
//                   colSpan="9"
//                   align="center"
//                   style={{ color: "#6b7280", padding: "20px" }}
//                 >
//                   Please select filters and click submit to view the report.
//                 </td>
//               </tr>
//             ) : emiData.length ? (
//               emiData.map((r, i) => {
//                 return (
//                   <tr key={r.id}>
//                     <td>
//                       {itemsPerPage === "All"
//                         ? i + 1
//                         : (currentPage - 1) * itemsPerPage + i + 1}
//                     </td>
//                     <td>{r.loanAccount?.groupName || "N/A"}</td>
//                     <td>
//                       {r.dueDate
//                         ? new Date(r.dueDate).toLocaleDateString("en-GB")
//                         : "N/A"}
//                     </td>
//                     <td>{r.loanAccount?.memberName || "N/A"}</td>
//                     <td>{r?.member?.fatherName||r?.member?.guardianName||r?.member?.husbandName || "N/A"}</td>
//                     <td>{r?.member?.mobileNumber|| "N/A"}</td>
//                     <td>{r.loanAccount?.loanAccountNumber || "N/A"}</td>
//                     <td>{r.installmentNo || "N/A"}</td>
//                     <td>₹{`${r.outstanding ? r.outstanding : 0}`}</td>
//                     <td>₹{`${r.emiAmount ? r.emiAmount : 0}`}</td>
//                     {/* <td>₹{`${r.emiBalance ? r.emiBalance : 0}`}</td> */}
//                   </tr>
//                 );
//               })
//             ) : (
//               <tr>
//                 <td colSpan="9" align="center">
//                   No data found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* PAGINATION */}
//       {hasSearched && itemsPerPage !== "All" && emiData.length > 0 && (
//         <div className="gledr-pagination">
//           <button
//             disabled={currentPage === 1 || emiData.length === 0}
//             onClick={() => setCurrentPage((p) => p - 1)}
//           >
//             ⬅ Prev
//           </button>

//           <span>
//             {emiData.length === 0
//               ? "No data"
//               : `Page ${currentPage} of ${totalPages}`}
//           </span>

//           <button
//             disabled={currentPage === totalPages || emiData.length === 0}
//             onClick={() => setCurrentPage((p) => p + 1)}
//           >
//             Next ➡
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CdsReport;




import React, { useState, useEffect } from "react";
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { ArrowLeftIcon, ArrowRightIcon, Download } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";

import "./CdsReport.css";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const CdsReport = () => {
  const navigate=useNavigate()
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);

  /* ---------------- STATES ---------------- */
  const [centers, setCenters] = useState([]);
  const [groups, setGroups] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState("");
  const [selectedGroup, setSelectedGroup] = useState("");
  const [dayFilter, setDayFilter] = useState("");
  const [loanTypeFilter, setLoanTypeFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [emiData, setEmiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [company, setCompany] = useState("");

  const ITEMS_PER_PAGE_OPTIONS = [10, 20, 50, 100, "All"];

        const hostname = window.location.hostname.split(".")[1];
  const companyName = company?.name || profile?.branchName || "Company";

  const selectedCenterName =
    centers.find((c) => c.id == selectedCenter)?.CenterName || "";

  const selectedCenterAddress =
    centers.find((c) => c.id == selectedCenter)?.city || "";

  /* ---------------- CUMULATIVE OVERDUE CALCULATION FIX ---------------- */
  const calculateOverdueAmount = (currentRow) => {
    if (!currentRow?.loanAccount?.loanAccountNumber) return 0;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Is specific member/account ke saare pichle overdue EMIs ka sum nikalenge
    const totalOverdueForAccount = filteredData.reduce((sum, r) => {
      // 1. Check karein ki kya ye record isi same account number ka hai
      if (
        r.loanAccount?.loanAccountNumber !==
        currentRow.loanAccount?.loanAccountNumber
      ) {
        return sum;
      }

      if (!r.dueDate) return sum;

      const dueDate = new Date(r.dueDate);
      dueDate.setHours(0, 0, 0, 0);

      const isUnpaid =
        r.status?.toLowerCase() !== "paid" &&
        r.status?.toLowerCase() !== "success" &&
        r.status?.toLowerCase() !== "settled";
      if (dueDate < today && isUnpaid) {
        return sum + Number(r.emiAmount || 0);
      }

      return sum;
    }, 0);

    return totalOverdueForAccount;
  };

  /* ---------------- PROFILE ---------------- */
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  /* ---------------- FETCH CENTERS ---------------- */
  useEffect(() => {
    if (!profile?.id) return;

    const fetchCenters = async () => {
      try {
        const res = await axios.get(
          `https://payyug.in/api/group/centre?LoanofficerId=${profile.id}&limit=10000`,
        );
        setCenters(res.data?.data || []);
      } catch (error) {
        console.error("Center fetch error:", error);
      }
    };

    fetchCenters();
  }, [profile?.id]);

  /* ---------------- FETCH GROUPS ---------------- */
  useEffect(() => {
    if (!selectedCenter) return;

    const fetchGroups = async () => {
      try {
        const res = await axios.get(
          `https://payyug.in/api/groupupdate/getall?LoanofficerId=${profile?.id}&CenterId=${selectedCenter}&limit=10000`,
        );
        setGroups(res.data?.data || []);
      } catch (error) {
        console.error("Group fetch error:", error);
      }
    };

    fetchGroups();
  }, [selectedCenter, profile?.id]);

  /* ---------------- FETCH EMI (INITIAL LOAD + FILTERS) ---------------- */
  const fetchEmis = async (page = 1) => {
    if (!profile?.superAdminId) return;

    try {
      setLoading(true);
      const res = await axios.get(
        "https://payyug.in/api/group-loan/emi/list-filter",
        {
          params: {
            superAdminId: profile.superAdminId,
            branchId: profile.branchId,
            centerId: selectedCenter || undefined,
            groupId: selectedGroup || undefined,
            // status:"PENDING",
            page,
            filterType: dayFilter || undefined,
            loanType: loanTypeFilter || undefined,
            fromDate: fromDate || undefined,
            toDate: toDate || undefined,
            search: searchQuery || undefined,
            limit: itemsPerPage === "All" ? 100000 : itemsPerPage,
          },
        },
      );

      if (res.data?.success) {
        setEmiData(res.data.data || []);
        setCurrentPage(res.data.currentPage || page);
        setTotalPages(res.data.totalPages || 1);
        setTotalRecords(res.data.totalRecords || 0);
      } else {
        setEmiData([]);
        setTotalPages(1);
        setTotalRecords(0);
        toast.error(res.data.message || "No data found");
      }
    } catch (error) {
      console.error("EMI fetch error:", error);
      toast.error("Failed to fetch data");
    } finally {
      setLoading(false);
      setHasSearched(true);
    }
  };

  // Initial load auto trigger
  useEffect(() => {
    if (profile?.superAdminId) {
      fetchEmis(currentPage);
    }
  }, [currentPage, itemsPerPage, profile]);

  // Debounced Search
  useEffect(() => {
    if (hasSearched) {
      const delayDebounceFn = setTimeout(() => {
        setCurrentPage(1);
        fetchEmis(1);
      }, 400);
      return () => clearTimeout(delayDebounceFn);
    }
  }, [searchQuery]);

  const handleFilter = () => {
    setCurrentPage(1);
    fetchEmis(1);
  };

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const res = await axios.get(
          `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`,
        );
        const data = res?.data;
        if (res.status === 200 && data) {
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          setCompany(data);
        }
      } catch (err) {
        console.error("Failed to fetch company details", err);
      }
    };

    if (profile?.superAdminId) fetchCompany();
  }, [profile?.superAdminId]);

  const toDataURL = (url) =>
    fetch(url)
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          }),
      );


        const filteredData = emiData.filter((r) => {
    const text = `
      ${r.loanAccount?.loanAccountNumber}
      ${r.loanAccount?.memberName}
      ${r.loanAccount?.centerName}
      ${r.loanAccount?.groupName}
    `.toLowerCase();

    return text.includes(searchQuery.toLowerCase());
  });

  /* ---------------- PDF GENERATION ---------------- */
  const handleCdsDownload = async () => {
    const doc = new jsPDF("l", "pt", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    let logoBase64 = null;
    if (company?.logoUrl) {
      try {
        logoBase64 = await toDataURL(company.logoUrl);
      } catch (e) {
        console.error("Logo conversion error: ", e);
      }
    }

    const totalDueSum = filteredData.reduce(
      (acc, r) => acc + Number(String(r.emiAmount || 0).replace(/,/g, "")),
      0,
    );

    const renderCdsHeader = (pdfDoc) => {
      pdfDoc.setFont("helvetica", "bold");
      pdfDoc.setFontSize(14);
      pdfDoc.setTextColor(0, 0, 0);
      pdfDoc.text("CENTER DEMAND SHEET", pageWidth / 2, 35, {
        align: "center",
      });

      if (logoBase64) {
        pdfDoc.addImage(logoBase64, "PNG", 40, 15, 50, 50);
      }

      pdfDoc.setFontSize(14);
      pdfDoc.setTextColor(40, 40, 40);

      const splitCompanyName = pdfDoc.splitTextToSize(
        companyName.toUpperCase(),
        250,
      );
      pdfDoc.text(splitCompanyName, pageWidth - 40, 35, {
        align: "right",
      });

      const companyLinesCount = Array.isArray(splitCompanyName)
        ? splitCompanyName.length
        : 1;
      let detailsY = 35 + companyLinesCount * 15;

      pdfDoc.setFont("helvetica", "normal");
      pdfDoc.setFontSize(8.5);
      pdfDoc.setTextColor(80, 80, 80);

      const lines = [
        `CIN: ${company?.cin || "-"}`,
        `Regd. Office: ${company?.address || "-"}`,
        `Contact: ${company?.contact || "-"}`,
        `Email: ${company?.email || "-"}`,
      ];

      lines.forEach((line) => {
        const splitText = pdfDoc.splitTextToSize(line, 250);
        pdfDoc.text(splitText, pageWidth - 40, detailsY, { align: "right" });
        detailsY += splitText.length * 11;
      });

      let currentY = detailsY + 20;

      pdfDoc.setFontSize(10);
      pdfDoc.setTextColor(0, 0, 0);

      const branchLabel = "Branch";
      const branchValue = `:  ${profile?.branchName || "N/A"}`;
      const villageLabel = "Village";
      const villageValue = `:  ${selectedCenterAddress}`;

      const splitBranchVal = pdfDoc.splitTextToSize(branchValue, 280);
      const splitVillageVal = pdfDoc.splitTextToSize(villageValue, 250);

      pdfDoc.setFont("helvetica", "bold");
      pdfDoc.text(branchLabel, 40, currentY);
      pdfDoc.setFont("helvetica", "normal");
      pdfDoc.text(splitBranchVal, 120, currentY);

      pdfDoc.setFont("helvetica", "bold");
      pdfDoc.text(villageLabel, 450, currentY);
      pdfDoc.setFont("helvetica", "normal");
      pdfDoc.text(splitVillageVal, 530, currentY);

      const maxRow1Lines = Math.max(
        splitBranchVal.length,
        splitVillageVal.length,
      );
      currentY += maxRow1Lines * 14 + 8;

      const centerLabel = "Center Name";
      const centerValue = `:  ${selectedCenterName}`;
      const officerLabel = "Loan Officer";
      const officerValue = `: ${hostname==="bhavikamfi"?"Suresh Kumar Saini" : ""}  `;

      const splitCenterVal = pdfDoc.splitTextToSize(centerValue, 280);
      const splitOfficerVal = pdfDoc.splitTextToSize(officerValue, 250);

      pdfDoc.setFont("helvetica", "bold");
      pdfDoc.text(centerLabel, 40, currentY);
      pdfDoc.setFont("helvetica", "normal");
      pdfDoc.text(splitCenterVal, 120, currentY);

      pdfDoc.setFont("helvetica", "bold");
      pdfDoc.text(officerLabel, 450, currentY);
      pdfDoc.setFont("helvetica", "normal");
      pdfDoc.text(splitOfficerVal, 530, currentY);

      const maxRow2Lines = Math.max(
        splitCenterVal.length,
        splitOfficerVal.length,
      );
      const finalHeaderBottomY = currentY + maxRow2Lines * 14 + 15;

      return finalHeaderBottomY;
    };

    const firstPageTableStartY = renderCdsHeader(doc);

    const tableBody = filteredData.map((r, i) => {
      const overdueAmount = calculateOverdueAmount(r);

      return [
        i + 1,
        r.loanAccount?.groupName || "N/A",
        r.dueDate ? new Date(r.dueDate).toLocaleDateString("en-GB") : "N/A",
        r.loanAccount?.memberName || "N/A",
        r?.member?.fatherName ||
          r?.member?.guardianName ||
          r?.member?.husbandName ||
          "N/A",
        r?.member?.mobileNumber || "N/A",
        r.loanAccount?.loanAccountNumber || "N/A",
        r.installmentNo || "N/A",
        r.outstanding ? `${r.outstanding}` : "0",
        r.emiAmount ? `${r.emiAmount}` : "0",
        overdueAmount,
        r.status,
        "",
        "",
        "",
      ];
    });

    // PDF me unique accounts ka total overdue nikalne ke liye logic
    const uniqueAccounts = {};
    filteredData.forEach((r) => {
      const accNo = r.loanAccount?.loanAccountNumber;
      if (accNo && !uniqueAccounts[accNo]) {
        uniqueAccounts[accNo] = calculateOverdueAmount(r);
      }
    });
    const totalOverdueSum = Object.values(uniqueAccounts).reduce(
      (acc, val) => acc + val,
      0,
    );

    const totalsRow = [
      {
        content: "Center Totals:",
        colSpan: 9,
        styles: { halign: "right", fontStyle: "bold" },
      },
      { content: `${totalDueSum.toFixed(2)}`, styles: { fontStyle: "bold" } },
      // {
      //   content: `${totalOverdueSum.toFixed(2)}`,
      //   styles: { fontStyle: "bold" },
      // },
      { content: "", colSpan: 5 },
    ];
    tableBody.push(totalsRow);

    autoTable(doc, {
      startY: firstPageTableStartY,
      head: [
        [
          "S.No",
          "Group Name",
          "Due Date",
          "Client Name",
          "Relationship Name",
          "Mobile No",
          "Account No.",
          "Inst. No.",
          "O/S",
          "EMI",
          "Total Due Amount",
          "Status",
          "Adv Amount",
          "Total Collection",
          "Client Sign",
        ],
      ],
      body: tableBody,
      theme: "grid",
      styles: {
        fontSize: 9,
        cellPadding: 5,
        halign: "center",
        valign: "middle",
        textColor: 0,
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: 0,
        fontStyle: "bold",
        lineWidth: 0.5,
        lineColor: 150,
      },
      columnStyles: {
        1: { halign: "left" },
        3: { halign: "left" },
      },
      margin: { top: 35, bottom: 45 },
      pageBreak: "auto",
    });

    /* ================= SUMMARY SHEET ================= */
    doc.addPage([841.89, 595.28], "landscape");

    const summaryPageContentStartY = renderCdsHeader(doc);
    let startY = summaryPageContentStartY + 10;

    doc.rect(40, startY, 400, 60);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text("CM Conduct Date: ________________", 48, startY + 20);
    doc.text("CM Start Time: _________", 200, startY + 20);
    doc.text("CM End Time: _________", 320, startY + 20);
    doc.text("Total Members in center: _________", 48, startY + 45);
    doc.text("Members Present: _________", 240, startY + 45);

    doc.rect(40, startY + 70, 400, 40);
    doc.text(`LO Name & Emp Id : ${profile?.name || "N/A"}`, 48, startY + 85);
    doc.text(
      "Remark if any : ____________________________________________________",
      48,
      startY + 100,
    );

    doc.rect(40, startY + 120, 400, 70);
    doc.text(
      "Visitor's Name & Emp Id : _____________________  Department: ___________",
      48,
      startY + 135,
    );
    doc.text(
      "Remark if any : ____________________________________________________",
      48,
      startY + 155,
    );
    doc.text("Signature : _______________________", 48, startY + 180);

    autoTable(doc, {
      startY: startY,
      margin: { left: 470 },
      tableWidth: 330,
      head: [["Denomination", "Amount"]],
      body: [
        ["2000 X", ""],
        ["500 X", ""],
        ["200 X", ""],
        ["100 X", ""],
        ["50 X", ""],
        ["20 X", ""],
        ["10 X", ""],
        ["5 X", ""],
        ["Coins", "(If any)"],
        ["Total", "Rupees:"],
      ],
      theme: "grid",
      styles: { fontSize: 8, cellPadding: 4, halign: "center" },
      headStyles: {
        fillColor: [245, 245, 245],
        textColor: 0,
        fontStyle: "bold",
      },
      columnStyles: { 0: { halign: "right", fontStyle: "bold", width: 150 } },
    });

    let footerY = startY + 230;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    doc.text("Center Leader Declaration:", 40, footerY);
    doc.setFont("helvetica", "normal");
    doc.text(
      "I hereby confirm that the recorded information related to our loan repayment and saving is true and we have handed over the required amount to loan officer.",
      165,
      footerY,
      { maxWidth: 630 },
    );

    doc.setFont("helvetica", "bold");
    doc.text(
      "Signature of Center Leader : _____________________",
      40,
      footerY + 45,
    );
    doc.text(
      "Signature of Loan Officer : _____________________",
      480,
      footerY + 45,
    );

    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text(
      "Disclaimer: - In case of Branch deposit by Member/Center Leader the responsibility of depositing the collection safely at branch lies solely with concerned member/Center leader.\nThey must ensure that the CDS copy received has Branch Stamp on it after they deposit the collection in Branch.",
      40,
      footerY + 80,
      { maxWidth: 760 },
    );

    doc.setFont("helvetica", "italic");
    doc.text(
      "Please keep this copy as a proof of your repayment towards loan & savings",
      40,
      footerY + 130,
    );

    const totalPagesCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPagesCount; i++) {
      doc.setPage(i);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(50);
      doc.text(
        `Page ${i} of ${totalPagesCount}`,
        pageWidth / 2,
        pageHeight - 15,
        { align: "center" },
      );
    }

    doc.save(`CDS_Report_${selectedCenterName}.pdf`);
  };

  return (
    <div className="gledr-container">
      {/* Back wrapper */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 16px",
          backgroundColor: "#fff",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          marginBottom: "20px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        }}
      >
        <ArrowLeftIcon
          onClick={() => navigate(-1)}
          style={{
            cursor: "pointer",
            padding: "4px",
            borderRadius: "4px",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#f5f5f5")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
        />

        <h2
          style={{
            margin: 0,
            fontSize: "18px",
            fontWeight: "600",
            color: "#333",
          }}
        >
          Center Demand Sheet
        </h2>

        <ArrowRightIcon
          onClick={() => navigate(1)}
          style={{
            cursor: "pointer",
            padding: "4px",
            borderRadius: "4px",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#f5f5f5")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
        />
      </div>

      {/* FILTER PANEL */}
      <div className="gledr-filterBox">
        <div className="gledr-filter-title">Filter By</div>

        <div className="gledr-filter-wrapper">
          <div className="gledr-filter-item">
            <div className="gledr-filter">
              <label>Loan Type</label>
              <select
                value={loanTypeFilter}
                onChange={(e) => setLoanTypeFilter(e.target.value)}
              >
                <option value="">All Types</option>
                <option value="FIXED">Fixed Loan</option>
                <option value="INDIVIDUAL">Individual Loan</option>
              </select>
            </div>

            <div className="gledr-filter">
              <label>Select Center</label>
              <select
                value={selectedCenter}
                onChange={(e) => {
                  setSelectedCenter(e.target.value);
                  setSelectedGroup("");
                }}
              >
                <option value="">All Centers</option>
                {centers.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.CenterName}
                  </option>
                ))}
              </select>
            </div>

            <div className="gledr-filter">
              <label>Select Group</label>
              <select
                value={selectedGroup}
                onChange={(e) => setSelectedGroup(e.target.value)}
                disabled={!selectedCenter}
              >
                <option value="">All Groups</option>
                {groups.map((g) => (
                  <option key={g.id} value={g.id}>
                    {g.groupname}, {g.groupcode}
                  </option>
                ))}
              </select>
            </div>

            <div className="gledr-filter">
              <label>Select Filter</label>
              <select
                value={dayFilter}
                onChange={(e) => setDayFilter(e.target.value)}
              >
                <option value="">All</option>
                <option value="today">Today</option>
                <option value="tomorrow">Tomorrow</option>
                <option value="pending">Pending</option>
                <option value="overdue">Overdue</option>
              </select>
            </div>

            <div className="gledr-filter">
              <label>From Date</label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>
            <div className="gledr-filter">
              <label>To Date</label>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
          </div>

          <div className="gledr-filter-submit-btn">
            <button className="submit-btn" onClick={handleFilter}>
              submit
            </button>
          </div>
        </div>
      </div>

      {/* SINGLE CDS DOWNLOAD BUTTON */}
      {filteredData.length > 0 && (
        <div
          className="gledr-pdf-download-btns"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "15px",
          }}
        >
          <button
            onClick={handleCdsDownload}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              backgroundColor: "#22c55e",
              color: "#ffffff",
              padding: "10px 20px",
              fontSize: "14px",
              fontWeight: "600",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <Download size={16} /> CDS Download
          </button>
        </div>
      )}

      {/* SEARCH + PER PAGE */}
        <div className="gledr-report-filter">
          <input
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setCurrentPage(1);
            }}
          />
          <div className="gledr-report-filter-inputs">
            <label>Show </label>
            <select
              value={itemsPerPage}
              onChange={(e) => {
                const value = e.target.value;
                setItemsPerPage(value === "All" ? "All" : Number(value));
                setCurrentPage(1);
              }}
            >
              {ITEMS_PER_PAGE_OPTIONS.map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>
        </div>

      {/* DATA TABLE */}
      <div className="gledr-report-table-container">
        <table className="gledr-report-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Group Name</th>
              <th>Due Date</th>
              <th>Client Name</th>
              <th>Relationship Name</th>
              <th>Mobile No</th>
              <th>Account No.</th>
              <th>Installment No.</th>
              <th>Outstanding</th>
              <th>EMI Amount</th>
              <th>Total Due Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="11" align="center">
                  Loading...
                </td>
              </tr>
            ) : filteredData.length ? (
              filteredData.map((r, i) => {
                const status = r.status?.toLowerCase() || "pending";
                return (
                  <tr key={r.id}>
                    <td>
                      {itemsPerPage === "All"
                        ? i + 1
                        : (currentPage - 1) * itemsPerPage + i + 1}
                    </td>
                    <td>{r.loanAccount?.groupName || "N/A"}</td>
                    <td>
                      {r.dueDate
                        ? new Date(r.dueDate).toLocaleDateString("en-GB")
                        : "N/A"}
                    </td>
                    <td>{r.loanAccount?.memberName || "N/A"}</td>
                    <td>
                      {r?.member?.fatherName ||
                        r?.member?.guardianName ||
                        r?.member?.husbandName ||
                        "N/A"}
                    </td>
                    <td>{r?.member?.mobileNumber || "N/A"}</td>
                    <td>{r.loanAccount?.loanAccountNumber || "N/A"}</td>
                    <td>{r.installmentNo || "N/A"}</td>
                    <td>₹{r.outstanding ? r.outstanding : 0}</td>
                    <td>₹{r.emiAmount ? r.emiAmount : 0}</td>
                    <td>₹{calculateOverdueAmount(r)}</td>
                    <td
                      className={
                        status === "paid"
                          ? "status-paid"
                          : status === "pending"
                            ? "status-pending"
                            : "status-overdue"
                      }
                      style={{ textTransform: "capitalize" }}
                    >
                      {r.status.toLowerCase()}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="11" align="center">
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      {itemsPerPage !== "All" && filteredData.length > 0 && (
        <div className="gledr-pagination">
          <button
            disabled={currentPage === 1 || filteredData.length === 0}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            ⬅ Prev
          </button>
          <span>{`Page ${currentPage} of ${totalPages}`}</span>
          <button
            disabled={currentPage === totalPages || filteredData.length === 0}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            Next ➡
          </button>
        </div>
      )}
    </div>
  );
};

export default CdsReport;
